import { redirectURI, defaultURL, authDomain, clientId, authAudience } from "../../../config";

const env = process.env.RUN_ENV;

export const AUTH_DOMAIN = authDomain[env];
export const CLIENT_ID = clientId[env];
export const REDIRECT_URI = redirectURI[env];
export const DEFAULT_URL = defaultURL[env];
export const AUTH_AUDIENCE = authAudience[env];
